module.exports = __webpack_public_path__ + "static/kingpin-5d39551c5ca6b3f3871359212a9e9cf2.jpg";